var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsLibraryIcon = function SvgDsLibraryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "M8 3.87C6.744 2.847 5.116 2.283 3.429 2.285c-.802 0-1.572.124-2.286.353v9.846a7.5 7.5 0 0 1 2.286-.354c1.756 0 3.358.599 4.571 1.583M8 3.87c1.256-1.021 2.884-1.585 4.571-1.583.802 0 1.571.124 2.286.353v9.846a7.5 7.5 0 0 0-2.286-.354c-1.687-.002-3.315.562-4.571 1.583M8 3.87v9.845"
  })));
};
export default SvgDsLibraryIcon;